<template>
  <div class="component-slam-mark" ref="slamRefWrap">
    <div class="slam-mark-point-container" :style="containerStyle"></div>
    <aside :style="{width: (showColorSelector || showWidthSelector) ? '210px' : 'unset'}">
      <ul class="operations" :style="operationsStyle">
        <li class="operation-btn on">
          <button><svg-icon icon-class="slam-mark"></svg-icon></button>
          <span>{{$t('calling.Arrow')}}</span>
        </li>
        <li class="operation-btn" :class="[showColorSelector ? 'on' : '']">
          <button @click="toggleColorSelector">
            <svg-icon icon-class="drawn-line-color"></svg-icon>
          </button>
          <span>{{$t('calling.Color')}}</span>
          <i></i>
          <ul v-show="showColorSelector" class="color-list">
            <li v-for="c in colorList" :key="c.name" :class="[c.selected ? 'selected' : '']">
              <i class="color-pointer" :style="{backgroundColor:c.color}" @click="selectColor(c.name)"></i>
            </li>
          </ul>
        </li>
        <li class="operation-btn">
          <button @click="undo"><svg-icon icon-class="draw-undo"></svg-icon></button>
          <span>{{$t('calling.Revoke')}}</span>
        </li>

        <li class="operation-btn">
          <button @click="clear"><svg-icon icon-class="draw-clear"></svg-icon></button>
          <span>{{$t('common.Clear')}}</span>
        </li>

        <!-- <li class="operation-btn">
          <button @click="save"><svg-icon icon-class="draw-save"></svg-icon></button>
          <span>保存</span>
        </li> -->

        <li class="operation-btn">
          <button @click="close"><svg-icon icon-class="draw-close"></svg-icon></button>
          <span>{{$t('common.Close')}}</span>
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
import Global from '@/global'

let pointContainerEl

// 获取二位数组最后一行，展开后的随机下标
function getIndexOfTwoDimensArrayOnLastRow(arrayOfTowDimens){
  const totalOfLastRow = arrayOfTowDimens[arrayOfTowDimens.length - 1].length
  const totalOfNotLastRow = arrayOfTowDimens.filter((i, index) => index < arrayOfTowDimens.length - 1).flat().length
  return totalOfNotLastRow + Math.floor(Math.random() * totalOfLastRow)
}

export default {
  name: 'SlamMark',

  props: {
    containerStyle: {
      type: Object,
      default: () => ({})
    },
    operationsStyle: {
      type: Object,
      default: () => ({})
    },
  },

  data () {
    return {
      showWidthSelector: false,
      showColorSelector: false,
      colorList: []
    }
  },

  created(){
    const selectIndex = getIndexOfTwoDimensArrayOnLastRow(Global.SLAM_MARK_COLOR_CODE)
    this.colorList = Global.SLAM_MARK_COLOR_CODE.flat().map((key, index) => { return { name: key, color: key, value: key.slice(1), selected: index === selectIndex } })
  },
  computed: {
    selectedColor () {
      return this.colorList.find(color => color.selected)
    }
  },

  mounted() {
    this.initContainerEl()
    this.bindContainerEvent()
  },

  methods: {
    initContainerEl () {
      // 加限定，其他组件可能会有相同的类名
      pointContainerEl = this.$refs.slamRefWrap.querySelector('.slam-mark-point-container')
    },

    // 点击时绘制标注点发送数据
    bindContainerEvent () {
      pointContainerEl.addEventListener('click', e => {
        const { offsetX, offsetY } = e
        const { width: cssWidth, height: cssHeight } = pointContainerEl.getBoundingClientRect()
        const ratioX = (offsetX < 0 ? 0 : offsetX > cssWidth ? cssWidth : offsetX) / cssWidth
        const ratioY = (offsetY < 0 ? 0 : offsetY > cssHeight ? cssHeight : offsetY) / cssHeight
        this.$emit('generate-slam-mark', {
          posX: ratioX,
          posY: ratioY,
          color: parseInt(`0x${this.selectedColor.value}`)
        })
        e.stopPropagation()
        e.cancelBubble = true
      }, true)
    },

    // 切换颜色选择
    toggleColorSelector () {
      this.showColorSelector = !this.showColorSelector
      this.showWidthSelector = false
    },

    // 选中颜色
    selectColor (name) {
      this.colorList.forEach(color => (color.selected = color.name === name))
      this.showColorSelector = false
    },

    closeMark () {
      this.$emit('close-slam-mark')
    },

    // 撤销
    undo () {
      this.$emit('undo-slam-mark')
    },

    // 清空
    clear () {
      this.$emit('clear-slam-mark')
    },

    // 关闭
    close () {
      this.$emit('close-slam-mark')
    },
  }
}
</script>

<style lang="scss" scoped>
.component-slam-mark {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .slam-mark-point-container {
    margin: 0;
    padding: 0;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    list-style: none;

    &::before {
      display: block;
      width: 100%;
      padding-top: 56.25%;
      content: '';
    }

    > li {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: -1;

      i {
        display: block;
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius: 50%;

        &.circle {
          animation: circle-fade 0.5s linear forwards;
        }

        &.solid {
          opacity: 0;
          animation: solid-fade 0.8s linear forwards;
        }
      }

    }
  }

  > aside {
    max-height: 100%;
    position: absolute;
    right: 0;
    // overflow-y: auto;

    .operations {
      margin: 0;
      padding: 16px 0;
      float: right;
      background-color: #FFFFFF;
      box-shadow: 0 5px 30px 0 rgba(89, 132, 219, 0.08);
      border-radius: 16px 0 0 16px;
      border: 1px solid #EDEFF2;
      border-right: none;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      list-style: none;
      user-select: none;

      .operation-btn {
        width: 120px;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        position: relative;
        margin-bottom: 15px;

        &.on {
          > button {
            color: #fff;
            background-color: #236CFF;

            &:hover {
              background-color: #236CFF;
            }
          }

          > i {
            background-color: #236CFF;
          }
        }

        > button {
          width: 56px;
          height: 56px;
          margin-bottom: 8px;
          padding: 0;
          font-size: 32px;
          background-color: #FFFFFF;
          box-shadow: 0 4px 6px 0 rgba(89, 132, 219, 0.08);
          border: 1px solid #EDEFF2;
          border-radius: 50%;
          cursor: pointer;
          color: #236CFF;

          &:hover {
            background-color: #F3F6FB;
          }
        }

        > span {
          line-height: 20px;
          font-size: 14px;
          color: #000000;
        }

        > i {
          display: block;
          width: 4px;
          height: 79px;
          background-color: #fff;
          position: absolute;
          top: 0;
          right: 0;
        }

        .color-list {
          position: absolute;
          top: 15px;
          left: -330px;
          width: 340px;
          padding: 10px;
          margin: 0;
          border-radius: 5px;
          display: flex;
          flex-flow: row wrap;
          background-color: #ffffff;
          list-style: none;
          box-shadow: 0 0 10px 5px rgba(0,0,0,0.08);
          &::before{
            content: '';
            display: block;
            position: absolute;
            top: 10px;
            right: -12px;
            width: 0;
            height: 0;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-left: 12px solid #ffffff;
          }
          > li {
            position: relative;
            box-sizing: content-box;
            padding: 5px;
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            .color-pointer {
              width: 18px;
              height: 18px;
              border-radius: 50%;
              cursor: pointer;
            }
            &.selected {
              border-radius: 50%;
              background-color: #EBEEF3;
              z-index: 0;
              &::before {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -14px;
                margin-top: -14px;
                content: '';
                display: block;
                width: 28px;
                height: 28px;
                border-radius: 50%;
                background-color: #ffffff;
                z-index: -1;
              }
              .color-pointer {
                width: 24px;
                height: 24px;
              }
            }
          }
        }

        .width-list {
          width: 56px;
          padding: 0;
          margin: 0;
          position: absolute;
          top: 0;
          left: -76px;
          display: flex;
          flex-flow: column nowrap;
          list-style: none;

          > li {
            width: 56px;
            height: 56px;
            display: flex;
            justify-content: center;
            align-items: center;

            &::before {
              content: '';
              display: block;
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }

            .width-pointer {
              width: 24px;
              height: 24px;
              position: absolute;
              background-color: #C7C9CD;
              border-radius: 50%;
              cursor: pointer;

              &.s {
                width: 8px;
                height: 8px;
              }

              &.m {
                width: 16px;
                height: 16px;
              }

              &.l {
                width: 24px;
                height: 24px;
              }

              &.xl {
                width: 32px;
                height: 32px;
              }
            }

            &.selected {
              &::before {
                background-color: #EBEEF3;
              }

              .width-pointer {
                background-color: #236CFF;
              }
            }
          }
        }
      }
    }
  }

  @keyframes circle-fade {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    70% {
      opacity: 1;
      transform: scale(1.5);
    }
    100% {
      opacity: 0;
      transform: scale(1.5);
    }
  }

  @keyframes solid-fade {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
}
</style>
